import { useNavigate } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { LiveStreamsController } from "./live-streams-controller";
import { LiveStreamsPage } from "./live-streams-page";

export function LiveStreamsRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  return (
    <Subtree
      key="live-streams"
      controller={() =>
        new LiveStreamsController(
          pick(deps, "client", "authHandler", "storeRepository", "locationsRepository", "shareLinks"),
          {
            toStream: (streamId) => navigate(`/live/streams/${streamId}`),
          },
        )
      }
    >
      <LiveStreamsPage />
    </Subtree>
  );
}
